import { dynamicBreadcrumbsReducer, flattenRoutes, keepOnlySidebarRoutes, } from '@sudoplatform-private/admin-web-utils';
import { Layout } from 'antd';
import { Resizable } from 're-resizable';
import React, { useMemo, useReducer } from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import { AppHeader } from '../AppHeader';
import { BreadCrumbs } from '../BreadCrumbs';
import { Sidebar } from '../Sidebar';
const Container = styled(Layout) `
  min-height: 100vh;
  min-width: 100vw;
  height: 100%;
  width: 100%;
`;
const StyledLayoutSider = styled(Layout.Sider) `
  height: 100%;
`;
const StyledLayoutHeader = styled(Layout.Header) `
  padding: 0;
`;
const StyledLayoutContent = styled(Layout.Content) `
  flex: 1;
  display: flex;
  flex-direction: column;
`;
const MainContent = styled.div `
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const ConsoleLayout = ({ projects, currentProject, rootPaths, routes, UserDropdown, onProjectSwitch, }) => {
    const [dynamicBreadcrumbs, addDynamicBreadcrumbs] = useReducer(dynamicBreadcrumbsReducer, new Map());
    const sidebarRoutes = useMemo(() => keepOnlySidebarRoutes(routes), [routes]);
    const breadcrumbRoutes = useMemo(() => flattenRoutes(routes).filter((r) => r.displayName), [flattenRoutes, routes]);
    return (React.createElement(Container, { className: "console-layout" },
        React.createElement(Resizable, { defaultSize: { width: 252, height: 'auto' }, minWidth: 252, maxWidth: "25%", enable: { right: true } },
            React.createElement(StyledLayoutSider, { width: "100%" },
                React.createElement(Sidebar, { routes: sidebarRoutes, projectId: currentProject?.id, projectRootPath: rootPaths['project'] ?? '/' }))),
        React.createElement(Layout, null,
            React.createElement(StyledLayoutHeader, null,
                React.createElement(AppHeader, { projectDropdownProps: { projects, currentProject, onProjectSwitch }, UserDropdown: UserDropdown })),
            React.createElement(StyledLayoutContent, null,
                React.createElement(BreadCrumbs, { routes: breadcrumbRoutes, rootPaths: Object.values(rootPaths), dynamicBreadcrumbs: dynamicBreadcrumbs }),
                React.createElement(MainContent, null,
                    React.createElement(Outlet, { context: { addDynamicBreadcrumbs } }))))));
};
